import { Box, Typography } from "@mui/material";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

export default function SobreCalculosCard() {
    return (
        <Box
            sx={{
                backgroundColor: "rgba(36, 59, 96, 0.6)",
                borderRadius: "8px",
                padding: "14px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "6px",
            }}
        >
            <Box sx={{ display: "flex", flexDirection: "row" }}>
                <CalendarTodayIcon sx={{ color: "#78a5cc", fontSize: "20px", marginRight: "8px" }} />
                <Typography sx={{ fontSize: "14px", color: "#78a5cc", fontWeight: "500" }}>
                    Sobre os Cálculos
                </Typography>
            </Box>
            <Box>
                <Typography sx={{ fontSize: "12px", color: "#78a5cc" }}>
                    Os valores são agregados conforme o período selecionado. O progresso anual mostra quanto já foi realizado em relação à meta total do ano. Os desvios críticos representam perdas significativas que impactam negativamente o atingimento das metas.
                </Typography>
            </Box>
        </Box>
    );
}
